// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

export const GET_WORKFLOW_FINDING_GROUPS =
  "mondoo.policy.ExtendedHub.GetWorkflowFindingGroups";
